<template lang="pug">
.t-content
  section.info-sec
    .faq
      .max-container
        p
          b.text-warning Contact Us
        p Our dedicated support team is available 24/7 to provide assistance whenever you need it. For quick answers, we recommend first checking our FAQ section to see if your question has already been addressed.
        p If you still need help or have additional inquiries, feel free to reach out to us. Our team is here to ensure you have a smooth and enjoyable experience on our platform!
        contactUs(:fixed="true" :content="false")
</template>
<script>
import contactUs from '@/views/default/_contactUs.vue'
export default{
  components:{
    contactUs
  },
  mounted(){
    window.scroll(0, 0)
  }
}
</script>